import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "CampaignEditorRow" }
const _hoisted_2 = {
  key: 0,
  class: "WarningWidget WarningWidgetPrimary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!
  const _component_ImportCampaignConfigurationModal = _resolveComponent("ImportCampaignConfigurationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoadingWrapper, {
      classes: [
			'CampaignEditorRow',
			'CampaignEditorSubtitle'
		],
      isLoading: _ctx.isLoading,
      tag: "h2"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode(" Import campaign configuration ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createVNode(_component_LoadingWrapper, {
      classes: [
			'CampaignEditorRow',
			'CampaignEditorText'
		],
      isLoading: _ctx.isLoading,
      tag: "p"
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createTextVNode(" Reuse organisations, studies, and geotargeting settings from an existing campaign. ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "HelperButton ImportCampaignConfigurationLink",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openImportModal && _ctx.openImportModal(...args)))
      }, " Import campaign configuration "),
      (_ctx.hasLinkedOrganisations)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "lnr-info WarningWidgetIcon" }, null, -1 /* CACHED */),
            _createElementVNode("span", { class: "WarningWidgetOuterContentWrapper" }, " Existing linked organisations will be replaced by the imported campaign's organisations. ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.isImportModalActive)
      ? (_openBlock(), _createBlock(_component_ImportCampaignConfigurationModal, { key: 0 }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}